<template>
  <div id="dashboard" style="padding-right: 10px;padding-left: 10px;">

    <!-- Stats Card w/ line chart -->
    <b-row>
      <b-col
        md="4"
        cols="4"
        style="padding-bottom: 0;"
      >
        <b-card
          body-class="pb-1"
        >
          <h6>پرسنل</h6>
          <h2 class="font-weight-bolder mb-1">
            {{ countUser }} نفر
          </h2>
          <!-- chart -->
        </b-card>
      </b-col>
      <b-col
        md="4"
        cols="4"
        style="padding-bottom: 0;"
      >
        <b-card
          body-class="pb-1"
        >
          <h6>حاضرین</h6>
          <h2 class="font-weight-bolder mb-1">
            {{ countP }} نفر
          </h2>
          <!-- chart -->
        </b-card>
      </b-col>
      <b-col
        md="4"
        cols="4"
        style="padding-bottom: 0;"
      >
        <b-card
          body-class="pb-1"
        >
          <h6>غایبین</h6>
          <h2 class="font-weight-bolder mb-1">
            {{ countUser-countP }} نفر
          </h2>
          <!-- chart -->
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col
        md="8"
        sm="12"
      >
        <div class="card">
          <b-card-header style="background: rgb(21, 174, 102) none repeat scroll 0% 0%;color: #fff;padding: 10px 20px;">
            حاضرین
            <date-picker
              v-model="today"
              style="margin: 0 5px;"
              append-to="body"
              @change="dateOnChange()"
            />
          </b-card-header>
          <b-card-body>
            <v-data-table
              :headers="headers"
              :items="desserts"
              :items-per-page="40"
              :sort-by.sync="columnName"
              :sort-desc.sync="isDescending"
              mobile-breakpoint="0"
              hide-default-footer
              disable-pagination
            >
              <template v-slot:item.userId="{ item }">
                {{ item.userId.fullname }}
              </template>
              <template v-slot:item.officetitle="{ item }">
                <tr
                  v-for="row in item.riz"
                  :key="row._id"
                >
                  {{ row.officetitle }}
                </tr>
              </template>
              <template v-slot:item.vorod="{ item }">
                <tr v-for="row in item.riz">
                  {{ row.timeEntry }}
                </tr>
              </template>
              <template v-slot:item.khoroj="{ item }">
                <tr v-for="row in item.riz">
                  {{ row.timeExit }}
                </tr>
              </template>
              <template v-slot:item.rizkarkard="{ item }">
                <tr v-for="row in item.riz">
                  {{ row.karkard }}
                </tr>
              </template>
              <template v-slot:no-data>
                <v-btn
                  variant="gradient-success"
                  @click="initialize"
                >
                  بروزرسانی
                </v-btn>
              </template>
            </v-data-table>
          </b-card-body>
        </div>
      </b-col>
      <b-col
        md="4"
        sm="12"
      >
        <div class="card">
          <b-card-header style="background: rgb(174, 78, 21) none repeat scroll 0% 0%;color: #fff;padding: 10px 20px;">
            غایبین
          </b-card-header>
          <b-card-body>
            <v-data-table
              :headers="headers2"
              :items="dessertsp"
              :items-per-page="40"
              :sort-by.sync="columnName"
              :sort-desc.sync="isDescending"
              mobile-breakpoint="0"
              hide-default-footer
              hide-default-header
              disable-pagination
            >
              <template v-slot:no-data>
                <v-btn
                  variant="gradient-success"
                  @click="initialize"
                >
                  بروزرسانی
                </v-btn>
              </template>
            </v-data-table>
          </b-card-body>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BCard, BCardBody, BCardHeader, BCardText, BLink, BButton, BRow, BCol,
} from 'bootstrap-vue'
import Vue from 'vue'
import VuePersianDatetimePicker from 'vue-persian-datetime-picker'
import moment from 'jalali-moment'
import router from '@/router'

import recordService from '@/services/record.service'
import userService from '@/services/user.service'

export default {
  components: {
    BCard,
    BCardBody,
    BCardHeader,
    BCardText,
    // eslint-disable-next-line vue/no-unused-components
    BLink,
    BButton,
    BRow,
    BCol,
    datePicker: VuePersianDatetimePicker,
  },
  data() {
    return {
      resRecord: [0],
      desserts: [],
      dessertsp: [],
      dessertsId: [],
      listUserId: [],
      listUser: [],
      countUser: 0,
      countP: 0,
      fromDate: 0,
      toDate: 0,
      columnName: 'date',
      isDescending: true,
      today: Vue.prototype.$functions.unixToPersianDateS(Vue.prototype.$functions.time()),
    }
  },
  computed: {
    headers() {
      return [
        {
          text: 'نام',
          align: 'start',
          sortable: false,
          // eslint-disable-next-line no-useless-concat
          value: 'userId',
        },
        { text: 'محل کار', value: 'officetitle' },
        { text: 'ورود', value: 'vorod', sortable: false },
        { text: 'خروج', value: 'khoroj', sortable: false },
        { text: 'کارکرد', value: 'rizkarkard', sortable: false },
        { text: 'جمع کارکرد', value: 'jamkarkard' },
      ]
    },
    headers2() {
      return [
        {
          text: 'نام',
          align: 'start',
          sortable: false,
          // eslint-disable-next-line no-useless-concat
          value: 'fullname',
        },
      ]
    },
  },
  async created() {
    this.fromDate = Vue.prototype.$functions.todayTimes().start
    this.toDate = 0
    this.userfilll()
  },
  methods: {
    startWork() {
      this.initialize()
      setTimeout(() => {
        // eslint-disable-next-line no-plusplus
        this.startWork()
      }, 30000)
    },
    dateOnChange() {
      const m = moment.from(this.today, 'fa', 'YYYY/MM/DD').unix()
      const start = new Date(m * 1000)
      start.setHours(0, 0, 0, 0)
      this.fromDate = start / 1000

      const end = new Date(m * 1000)
      end.setHours(23, 59, 59, 0)
      this.toDate = end / 1000
      this.initialize()
    },
    addClick() {
      router.push({ path: '/tick/map' })
    },
    userfilll() {
      this.countUser = 0
      this.listUserId = []
      this.listUser = []
      userService.getList({ companyId: localStorage.getItem('companySelected') }).then(
        res => {
          if (res.status === 'success') {
            if ('result' in res && 'data' in res.result && res.result.data.length > 0) {
              for (let i = 0; i <= res.result.data.length - 1; i++) {
                if(res.result.data[i].active){
                  this.countUser += 1
                  this.listUserId.push(res.result.data[i].userId._id)
                  this.listUser.push(res.result.data[i])
                }
              }
              this.startWork()
            }
          }
        },
      )
    },
    initialize() {
      recordService.getList({
        companyId: localStorage.getItem('companySelected'),
        officeId: 0,
        filterUser: this.listUserId,
        fromDate: this.fromDate,
        toDate: this.toDate,
      }).then(
        res => {
          this.countP = 0
          this.desserts = []
          this.dessertsp = []
          this.dessertsId = []
          const resData = JSON.parse(JSON.stringify(res))
          if (resData.status === 'success') {
            let lastDate = 0
            let lastUser = 0
            let firstime = 0
            if ('result' in resData && 'data' in resData.result && resData.result.data.length > 0) {
              for (let i = 0; i <= resData.result.data.length - 1; i++) {
                const temp = resData.result.data[i]

                const riz = {}
                riz.karkard = 0
                riz.timeEntrys = temp.timeEntry
                riz.timeExits = temp.timeExit
                if (temp.timeExit) {
                  const hours = Math.floor((temp.timeExit - temp.timeEntry) / 3600)
                  const totalSeconds = (temp.timeExit - temp.timeEntry) % 3600
                  const minutes = Math.floor(totalSeconds / 60)
                  riz.karkard = `${hours}:${minutes}`
                }
                temp.date = new Date(temp.timeEntry * 1000).toLocaleDateString('fa-IR', { year: 'numeric', month: '2-digit', day: '2-digit' })
                riz.timeEntry = new Date(temp.timeEntry * 1000).toLocaleTimeString('fa-IR', { hour: '2-digit', minute: '2-digit' })
                riz.timeExit = '-'
                if (temp.timeExit) { riz.timeExit = new Date(temp.timeExit * 1000).toLocaleTimeString('fa-IR', { hour: '2-digit', minute: '2-digit' }) }
                riz.officetitle = temp.officeId.title
                // eslint-disable-next-line no-underscore-dangle
                riz._id = temp._id
                temp.userId.fullname = `${temp.userId.fName} ${temp.userId.lName}`

                if (lastDate !== temp.date || lastUser !== temp.userId.fullname) {
                  temp.riz = []
                  this.desserts.push(temp)
                }

                this.desserts[this.desserts.length - 1].riz.push(riz)
                lastDate = temp.date
                lastUser = temp.userId.fullname
                this.dessertsId.push(temp.userId.userId)
              }
              const tp = []
              for (let i = 0; i <= this.desserts.length - 1; i++) {

                this.countP += 1
                const temp = this.desserts[i]
                temp.jamkarkard = 0
                let jam = 0
                temp.riz.forEach(val => {
                  if (val.timeExits) {
                    jam += val.timeExits - val.timeEntrys
                  }
                })
                const hours1 = Math.floor(jam / 3600)
                const totalSeconds1 = jam % 3600
                const minutes1 = Math.floor(totalSeconds1 / 60)
                temp.jamkarkard = `${hours1}:${minutes1}`

                tp.push(temp)
              }
              this.desserts = tp


              this.listUser.forEach(user => {
                // eslint-disable-next-line no-underscore-dangle
                if (!this.dessertsId.includes(user.userId._id)) {
                  user.fullname = `${user.fName} ${user.lName}`
                  this.dessertsp.push(user)
                }
              })
            }
          }
        },
        error => {
          this.message = (error.response && error.response.data)
                || error.message
                || error.toString()
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'register error',
              text: this.message,
              icon: 'XIcon',
              variant: 'danger',
            },
          })
        },
      )
    },
  },
}
</script>

<style>
.vpd-input-group {
  border: 1px solid #fff;
  border-radius: 5px;
}
#dashboard .vpd-input-group label{
  background-color: rgba(255, 255, 255, 0) !important;
  color: #fff;
}
#dashboard .vpd-input-group input{
  background-color: #fff0 !important;
  border: 0 !important;
  color: #fff;
  padding-right: 0px;
  width: 100px !important;
  padding-bottom: 0;
  padding-top: 3px;
  height: auto;
}
#dashboard .card-header{
  padding: 8px 20px !important;
  min-height: 50px;
}
</style>
